import { useLocation } from 'react-router-dom';

import parentPaths from '../paths';

const useSection = () => {
  const location = useLocation();

  const pathSplitted = location.pathname.split(parentPaths.default);
  const sections = pathSplitted.length > 1 ? pathSplitted[1].split('/').slice(1) : [];

  return sections;
};

export default useSection;
